import { jsx as _jsx } from "react/jsx-runtime";
import { TypographyText } from '../_core';
import styles from '../typography.module.css';
const SIZE_CLASS = {
    lg: styles['body-lg'],
    md: styles['body-md'],
    sm: styles['body-sm'],
};
const COLOR_VAR = {
    foreground: undefined, // inherit — no override
    mute: 'var(--muted-foreground)',
    primary: 'var(--primary)',
    destructive: 'var(--destructive)',
    success: 'var(--success)',
    warning: 'var(--warning)',
};
/**
 * Body text. Renders `<p>` by default.
 *
 * lg=16 (long-form opt-in), md=14 (DEFAULT — feeds, messages, forms), sm=12 (dense).
 * Sans 400.
 *
 * For muted secondary text, prefer `<Caption>` (bakes muted color in).
 * Use `color="mute"` here when you need body-scale muted text.
 *
 * Do not override fontSize, fontFamily, lineHeight, fontWeight, or
 * letterSpacing via style prop.
 */
export function Body({ size = 'md', color = 'foreground', as = 'p', children, style, ...rest }) {
    return (_jsx(TypographyText, { as: as, roleClassName: SIZE_CLASS[size], color: COLOR_VAR[color], style: style, ...rest, children: children }));
}
//# sourceMappingURL=Body.js.map